import React from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './Accordion.module.css';
import CaretDownBoldIcon from '../icons/CaretDownBoldIcon';

const Accordion = React.forwardRef(function Accordion(
  { title, children, defaultOpen = false, className, ...rest },
  ref
) {
  const [open, setOpen] = React.useState(defaultOpen);

  return (
    <div ref={ref} className={cn(styles.root, className)} {...rest}>
      <button
        type='button'
        className={styles.trigger}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}>
        <span className={styles.title}>{title}</span>
        <span
          className={cn(styles.icon, open && styles.iconOpen)}
          aria-hidden='true'>
          <CaretDownBoldIcon size={12} />
        </span>
      </button>
      <div
        className={cn(styles.body, open && styles.bodyOpen)}
        aria-hidden={!open}>
        <div className={styles.bodyInner}>{children}</div>
      </div>
    </div>
  );
});

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string
};

export default Accordion;
